export default __webpack_public_path__ + "static/teaBag-dacd644e32d0e432c599e6a8389b0411.png";